import React, { memo, useCallback } from 'react'
import { Form, Formik } from 'formik'
import { CreateCustomerFormContent } from './CreateCustomerFormContent'
import { createCustomerValidator } from './CreateCustomerForm.validator'
import type { CreateCustomerFormValues } from './CreateCustomerForm.interface'

const INITIAL_VALUES: CreateCustomerFormValues = {
  name: '',
  logo: null,
}

interface Props {
  formId: string
  onSubmit(values: CreateCustomerFormValues): void
}

const CreateCustomerFormComponent = ({ formId, onSubmit }: Props) => {
  const handleSubmit = useCallback(
    (values: CreateCustomerFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<CreateCustomerFormValues>
      initialValues={INITIAL_VALUES}
      validationSchema={createCustomerValidator}
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <CreateCustomerFormContent />
      </Form>
    </Formik>
  )
}

export const CreateCustomerForm = memo(CreateCustomerFormComponent)
